<template>
  <v-card elevation="0">
    <v-card-title>Statistique des services</v-card-title>
    <v-card-text>
      <template v-if="loading==false">
        <bar-chart :chartdata="chartdata" :options="options" :height="300"></bar-chart>
      </template>
      <v-progress-circular v-else indeterminate color="orange darken-2"></v-progress-circular>
    </v-card-text>
  </v-card>
</template>

<script>
import BarChart from "@/components/dashboard/charts/Bar.vue";
import { mapActions } from "vuex";
export default {
  components: { BarChart },
  data: () => ({
    data: 0,
    loading: true,
    options: {
      legend: {
        display: false
      },
      maintainAspectRatio: false,
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true
            }
          }
        ]
      }
    },
    chartdata: {
      labels: ["January", "February", "March", "April"],
      datasets: [
        {
          label: "Commandes",
          fill: false,
          borderColor: "#0a252c",
          data: [40, 20, 30, 400]
        }
      ]
    }
  }),
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.loading = true;
      this.serviceUsage()
        .then(data => {
          this.chartdata.labels = data.data.labels;
          this.chartdata.datasets[0].data = data.data.datas;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    ...mapActions("statistique", ["serviceUsage"])
  }
};
</script>

<style>
</style>